import { render, staticRenderFns } from "./stu.vue?vue&type=template&id=7f38989a&scoped=true"
import script from "./stu.vue?vue&type=script&lang=js"
export * from "./stu.vue?vue&type=script&lang=js"
import style0 from "./stu.vue?vue&type=style&index=0&id=7f38989a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f38989a",
  null
  
)

export default component.exports